import { render, staticRenderFns } from "./AkbankConfig.vue?vue&type=template&id=195e6235&scoped=true&"
import script from "./AkbankConfig.vue?vue&type=script&lang=js&"
export * from "./AkbankConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e6235",
  null
  
)

export default component.exports